import React, { useState, useEffect, useTransition, useContext } from 'react'
import { MdBookmarkAdd, MdBookmarkAdded } from "react-icons/md";
import PieChart from './../components/PieChart';
import Barchart from './../components/Barchart';
import HighChartPie from './../components/HighChartPie';
import HighChartBarCategories from './../components/HighChartBarCategories';
import HighChartBar from './../components/HighChartBar';
import HighChartColumn from './../components/HighChartColumn';
import { mainDashboardStats } from './../api/axiosDashboards';
import { capitalizeFirstLetter } from './../utilities/UtilityFunctions';
import { useMediaQuery } from 'react-responsive';
import { calculateFontSize } from './../utilities/calculateFontSize';
import { useTranslation } from 'react-i18next';
import DataContext from '../context/DataContext';
import { getAllCountries } from '../api/axiosCountries';
import { getCountryRegions } from '../api/axiosRegions';
import { getAllRoles } from '../api/axiosRoles';
import { Dropdown } from 'primereact/dropdown';
import { Skeleton } from 'primereact/skeleton';
import { Calendar } from 'primereact/calendar';


const Home = () => {
  const { t } = useTranslation();
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const monthsSw = ["Januari", "Februari", "Machi", "Aprili", "Mei", "Juni", "Julai", "Agosti", "Septemba", "Oktoba", "Novemba", "Desemba"];
  const { language,setCountries,setRegions,setRoles,setFetcherror } = useContext(DataContext);
  
  
  let newdate = new Date();
  let month = newdate.getMonth();
  let year = newdate.getFullYear();
  const monthNames = language === "TZ" ? monthsSw : months;
  
  const [mainStats, setMainStats] = useState([]);
  // const [fetcherror, setFetcherror] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const [period, setPeriod] = useState("monthly"); // monthly | quarterly | annually | range
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedYear, setSelectedYear] = useState(year);
  const [selectedMonth, setSelectedMonth] = useState(month + 1); // 1-12
  const [selectedQuarter, setSelectedQuarter] = useState(Math.floor(month / 3) + 1); // 1-4

  const yearOptions = Array.from({ length: 7 }).map((_, i) => {
    const y = year - 5 + i;
    return { label: `${y}`, value: y };
  });

  const monthOptions = monthNames.map((m, idx) => ({ label: m, value: idx + 1 }));
  const quarterOptions = [
    { label: "Q1", value: 1 },
    { label: "Q2", value: 2 },
    { label: "Q3", value: 3 },
    { label: "Q4", value: 4 },
  ];

  const formatTitleRange = (d) => {
    if (!d) return "";
    const dd = String(d.getDate()).padStart(2, "0");
    const m = monthNames[d.getMonth()];
    const yyyy = d.getFullYear();
    return `${dd} ${m} ${yyyy}`;
  };

  const getDashboardTitle = () => {
    if (period === "monthly") {
      const mName = monthNames[(selectedMonth || (month + 1)) - 1] || monthNames[month];
      const y = selectedYear || year;
      return `${t('INCIDENTS DASHBOARD')} - ${mName} ${y}`;
    }
    if (period === "quarterly") {
      const y = selectedYear || year;
      const q = selectedQuarter || (Math.floor(month / 3) + 1);
      return `${t('INCIDENTS DASHBOARD')} - Q${q} ${y}`;
    }
    if (period === "annually") {
      const y = selectedYear || year;
      return `${t('INCIDENTS DASHBOARD')} - ${y}`;
    }
    if (period === "range") {
      const left = startDate ? formatTitleRange(startDate) : "";
      const right = endDate ? formatTitleRange(endDate) : "";
      if (left && right) return `${t('INCIDENTS DASHBOARD')} - ${left} - ${right}`;
      if (left) return `${t('INCIDENTS DASHBOARD')} - ${left}`;
      return `${t('INCIDENTS DASHBOARD')}`;
    }
    return `${t('INCIDENTS DASHBOARD')}`;
  };

  const hometitle = getDashboardTitle();

  useEffect(() => {
    getAllCountries(setCountries, setFetcherror, (data, error) => {
      if (data) {
        getCountryRegions(setRegions, setFetcherror, (data?.find((c) => c.name === "TANZANIA"))?.id);
      }
    });
    getAllRoles(setRoles, setFetcherror, (data, error) => {
      if (data) {
        //  console.log("roles", data);
      }
    });
    
  }, []);

  useEffect(() => {
    setIsLoading(true);

    const params = { period };
    if (period === "monthly") {
      params.year = selectedYear;
      params.month = selectedMonth;
    }
    if (period === "quarterly") {
      params.year = selectedYear;
      params.quarter = selectedQuarter;
    }
    if (period === "annually") {
      params.year = selectedYear;
    }
    if (period === "range") {
      const formatDateOnly = (d) => {
        if (!d) return "";
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const dd = String(d.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
      };

      if (startDate) params.startDate = formatDateOnly(startDate);
      if (endDate) params.endDate = formatDateOnly(endDate);
    }

    mainDashboardStats(setMainStats, setFetcherror, setIsLoading, params);
  }, [period, startDate, endDate, selectedYear, selectedMonth, selectedQuarter]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = useMediaQuery({ query: '(max-width: 969px)' })
  
  
 

  // Inline styles for the chart containers
  const chartContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    backgroundColor: '#FFF',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.25)',
    borderBottom: '1px solid #f8f9fa',
    padding: '30px 0',
    borderRadius: '4px',
    marginBottom: '25px'
  };

  const mobileChartContainerStyle = {
    ...chartContainerStyle,
    padding: '10px 0'
  };

  const isDesktopWide = screenWidth >= 1200;

  const dashboardCardsRowStyle = isDesktopWide
    ? { display: 'flex', flexWrap: 'nowrap', gap: '10px', width: '100%' }
    : {};

  const dashboardCardColStyle = isDesktopWide
    ? { flex: '1 1 0', minWidth: 0, padding: '0.25rem' }
    : {};

  const dashboardCardStyle = isDesktopWide
    ? { paddingLeft: '0.75rem', paddingRight: '0.75rem', paddingTop: '0.9rem', paddingBottom: '0.9rem' }
    : {};

  const overviewTitleStyle = {
    fontSize: `${calculateFontSize(screenWidth, 13, 11)}px`,
    whiteSpace: isDesktopWide ? 'nowrap' : 'normal',
    overflow: isDesktopWide ? 'hidden' : 'visible',
    textOverflow: isDesktopWide ? 'ellipsis' : 'clip',
    lineHeight: isDesktopWide ? '1.1' : '1.2'
  };

  const overviewNumberStyle = {
    fontSize: `${calculateFontSize(screenWidth, 14, 10)}px`,
    lineHeight: '1.15',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  };

  const overviewSubTextStyle = {
    fontSize: `${calculateFontSize(screenWidth, 11, 10)}px`,
    lineHeight: '1.2',
    whiteSpace: isDesktopWide ? 'nowrap' : 'normal',
    overflow: isDesktopWide ? 'hidden' : 'visible',
    textOverflow: isDesktopWide ? 'ellipsis' : 'clip'
  };

  const controlsRowStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    marginTop: '10px',
    flexWrap: 'wrap'
  };

  const controlsItemStyle = {
    width: screenWidth <= 520 ? '100%' : undefined,
    minWidth: screenWidth <= 520 ? undefined : '6.2rem'
  };

  const dateInputStyle = {
    width: screenWidth <= 520 ? '100%' : '9rem'
  };

  const periodDropdownStyle = screenWidth <= 520
    ? { width: '100%' }
    : { width: '7.5rem' };

  const monthQuarterDropdownStyle = screenWidth <= 520
    ? { width: '100%' }
    : { width: '6.4rem' };

  const yearDropdownStyle = screenWidth <= 520
    ? { width: '100%' }
    : { width: '5.2rem' };

  const compactControlStyle = {
    height: "32px",
    fontSize: "12px",
    padding: 0
  };

  const compactInputStyle = {
    fontSize: "11px",
    padding: "0.10rem 0.25rem"
  };

  // Small wrappers so we control sizing in one place
  const DashboardDropdown = ({ style, inputStyle, pt, ...props }) => (
    <Dropdown
      {...props}
      style={{ ...controlsItemStyle, ...style, ...compactControlStyle }}
      inputStyle={{ ...compactInputStyle, ...inputStyle }}
      pt={{
        root: { style: { overflow: 'hidden' } },
        label: { style: { padding: '0.10rem 0.25rem', fontSize: '11px' } },
        trigger: { style: { width: '1.6rem', padding: '0 0.25rem' } },
        ...pt
      }}
    />
  );

  const DashboardCalendar = ({ style, inputStyle, ...props }) => (
    <Calendar
      {...props}
      style={{ ...style, ...compactControlStyle }}
      inputStyle={{ ...compactInputStyle, ...inputStyle }}
    />
  );

  return (
    <div style={{ paddingRight: '5px', paddingLeft: '5px' }}>
      <div style={controlsRowStyle}>
        <DashboardDropdown
          value={period}
          onChange={(e) => setPeriod(e.value)}
          options={[
            { label: t("Monthly"), value: "monthly" },
            { label: t("Quarterly"), value: "quarterly" },
            { label: t("Annually"), value: "annually" },
            { label: t("Specific Range"), value: "range" }
          ]}
          placeholder={t("Select Period")}
          style={periodDropdownStyle}
        />

        {period === "monthly" && (
          <>
            <DashboardDropdown
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.value)}
              options={monthOptions}
              style={monthQuarterDropdownStyle}
            />
            <DashboardDropdown
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.value)}
              options={yearOptions}
              style={yearDropdownStyle}
            />
          </>
        )}

        {period === "quarterly" && (
          <>
            <DashboardDropdown
              value={selectedQuarter}
              onChange={(e) => setSelectedQuarter(e.value)}
              options={quarterOptions}
              style={monthQuarterDropdownStyle}
            />
            <DashboardDropdown
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.value)}
              options={yearOptions}
              style={yearDropdownStyle}
            />
          </>
        )}

        {period === "annually" && (
          <DashboardDropdown
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.value)}
            options={yearOptions}
            style={yearDropdownStyle}
          />
        )}

        {period === "range" && (
          <>
            <DashboardCalendar
              value={startDate}
              onChange={(e) => setStartDate(e.value)}
              className={screenWidth <= 520 ? "w-full" : ""}
              placeholder={t("Select Start Date")}
              dateFormat="dd/mm/yy"
              showIcon
              style={dateInputStyle}
            />
            <DashboardCalendar
              value={endDate}
              onChange={(e) => setEndDate(e.value)}
              className={screenWidth <= 520 ? "w-full" : ""}
              placeholder={t("Select End Date")}
              dateFormat="dd/mm/yy"
              showIcon
              style={dateInputStyle}
            />
          </>
        )}

        {isLoading && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Skeleton width="7rem" height="2.2rem" borderRadius="6px" />
          </div>
        )}
      </div>

      <div style={{ 
        display: 'flex', 
        flexDirection: 'row', 
        alignContent: 'center', 
        justifyContent: 'center', 
        marginTop: '20px', 
        marginBottom: '20px',
        textAlign: 'center',
        paddingLeft: screenWidth <= 520 ? '6px' : undefined,
        paddingRight: screenWidth <= 520 ? '6px' : undefined,
        fontSize: `${calculateFontSize(screenWidth, 24, 16)}px`, 
        fontWeight: '600', 
        color: '#41A6D7' 
      }}>
        {isLoading ? (
          <Skeleton width={screenWidth >= 600 ? "28rem" : "16rem"} height="1.8rem" />
        ) : (
          hometitle
        )}
      </div>
      
      <div className="layout-dashboard">
        {isLoading ? (
          <div className="grid" style={dashboardCardsRowStyle}>
            {[1, 2, 3, 4, 5].map((k) => (
              <div key={k} className="col-12 md:col-6 xl:col-3" style={dashboardCardColStyle}>
                <div className="cardWG grid-nogutter widget-overview-box" style={dashboardCardStyle}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <Skeleton shape="circle" size="2rem" />
                    <Skeleton width="70%" height="0.9rem" />
                  </div>
                  <div className="grid overview-detail" style={{ marginTop: '10px' }}>
                    <div className="col-6">
                      <Skeleton width="60%" height="1.2rem" />
                      <div style={{ marginTop: '6px' }}>
                        <Skeleton width="70%" height="0.8rem" />
                      </div>
                    </div>
                    <div className="col-6">
                      <Skeleton width="60%" height="1.2rem" />
                      <div style={{ marginTop: '6px' }}>
                        <Skeleton width="70%" height="0.8rem" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="grid" style={dashboardCardsRowStyle}>
            <div className="col-12 md:col-6 xl:col-3" style={dashboardCardColStyle}>
              <div className="cardWG grid-nogutter widget-overview-box widget-overview-box-1" style={dashboardCardStyle}>
                <span className="overview-icon">
                  <i className="pi pi pi-bars"></i>
                </span>
                <span className="overview-title" style={overviewTitleStyle}>{t('All Incidents')}</span>
                <div className="grid overview-detail">
                  <div className="col-6">
                    <div className="overview-number" style={overviewNumberStyle}>{mainStats?.currentincidentscounts?.submitted || 0}</div>
                    <div className="overview-subtext" style={overviewSubTextStyle}> {t('Submitted')}</div>
                  </div>
                  <div className="col-6">
                    <div className="overview-number" style={overviewNumberStyle}>{mainStats?.currentincidentscounts?.valid || 0}</div>
                    <div className="overview-subtext" style={overviewSubTextStyle}>{t('Valid')}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 md:col-6 xl:col-3" style={dashboardCardColStyle}>
              <div className="cardWG grid-nogutter widget-overview-box widget-overview-box-2" style={dashboardCardStyle}>
                <span className="overview-icon">
                  <i className="pi pi-inbox"></i>
                </span>
                <span className="overview-title" style={overviewTitleStyle}>{t('By Monitors')}</span>
                <div className="grid overview-detail">
                  <div className="col-6">
                    <div className="overview-number" style={overviewNumberStyle}>{mainStats?.currentmonitorincidentscounts?.submitted || 0}</div>
                    <div className="overview-subtext" style={overviewSubTextStyle}>{t('Submitted')}</div>
                  </div>
                  <div className="col-6">
                    <div className="overview-number" style={overviewNumberStyle}>{mainStats?.currentmonitorincidentscounts?.valid || 0}</div>
                    <div className="overview-subtext" style={overviewSubTextStyle}>{t('Valid')}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 md:col-6 xl:col-3" style={dashboardCardColStyle}>
              <div className="cardWG grid-nogutter widget-overview-box widget-overview-box-3" style={dashboardCardStyle}>
                <span className="overview-icon">
                  <i className="pi pi-users"></i>
                </span>
                <span className="overview-title" style={overviewTitleStyle}>{t('By the Public')}</span>
                <div className="grid overview-detail">
                  <div className="col-6">
                    <div className="overview-number" style={overviewNumberStyle}>{mainStats?.currentcitizenincidentscounts?.submitted || 0}</div>
                    <div className="overview-subtext" style={overviewSubTextStyle}>{t('Submitted')}</div>
                  </div>
                  <div className="col-6">
                    <div className="overview-number" style={overviewNumberStyle}>{mainStats?.currentcitizenincidentscounts?.valid || 0}</div>
                    <div className="overview-subtext" style={overviewSubTextStyle}>{t('Valid')}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 md:col-6 xl:col-3" style={dashboardCardColStyle}>
              <div className="cardWG grid-nogutter widget-overview-box widget-overview-box-4" style={dashboardCardStyle}>
                <span className="overview-icon">
                  <i className="pi pi-sort-amount-up-alt"></i>
                </span>
                <span className="overview-title" style={overviewTitleStyle}>{t('Leading')}</span>
                <div className="grid overview-detail">
                  <div className="col-6">
                    <div className="overview-number text-red-600" style={overviewNumberStyle}>{mainStats?.currentLeadingcounts?.issue?.name || t("No Incident Yet")}</div>
                    <div className="overview-subtext" style={overviewSubTextStyle}>{t('Issue')}</div>
                  </div>
                  <div className="col-6">
                    <div className="overview-number text-red-600" style={overviewNumberStyle}>{ mainStats?.currentLeadingcounts?.region?.name || t("No Incident Yet")}</div>
                    <div className="overview-subtext" style={overviewSubTextStyle}>{t('Region')}</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 md:col-6 xl:col-3" style={dashboardCardColStyle}>
              <div className="cardWG grid-nogutter widget-overview-box widget-overview-box-1" style={dashboardCardStyle}>
                <span className="overview-icon">
                  <i className="pi pi-comment"></i>
                </span>
                <span className="overview-title" style={overviewTitleStyle}>{t('Responded Incidents')}</span>
                <div className="grid overview-detail">
                  <div className="col-6">
                    <div className="overview-number" style={overviewNumberStyle}>{mainStats?.currentrespondedincidentscounts?.submitted || 0}</div>
                    <div className="overview-subtext" style={overviewSubTextStyle}> {t('Submitted')}</div>
                  </div>
                  <div className="col-6">
                    <div className="overview-number" style={overviewNumberStyle}>{mainStats?.currentrespondedincidentscounts?.valid || 0}</div>
                    <div className="overview-subtext" style={overviewSubTextStyle}>{t('Valid')}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Charts Section using PrimeFlex Grid */}
      <div className="grid" style={{ marginTop: '25px' }}>
        {/* Row 1 */}
        <div className="col-12 md:col-6">
          <div style={isMobile ? mobileChartContainerStyle : chartContainerStyle}>
            {isLoading ? (
              <div style={{ width: '100%' }}>
                <Skeleton width="60%" height="1rem" />
                <div style={{ marginTop: '10px' }}>
                  <Skeleton width="100%" height={isMobile ? "220px" : "280px"} />
                </div>
              </div>
            ) : (
              <HighChartPie
                chartData={mainStats.currentincidentsourcescounts ? Object.entries(mainStats.currentincidentsourcescounts).map(([name, y]) => ({ name: capitalizeFirstLetter(name), y })) : []}
                chartName={t('Incident Sources')}
                className="charCanvas"
              />
            )}
          </div>
        </div>
        
        <div className="col-12 md:col-6">
          <div style={isMobile ? mobileChartContainerStyle : chartContainerStyle}>
            {isLoading ? (
              <div style={{ width: '100%' }}>
                <Skeleton width="60%" height="1rem" />
                <div style={{ marginTop: '10px' }}>
                  <Skeleton width="100%" height={isMobile ? "220px" : "280px"} />
                </div>
              </div>
            ) : (
              <HighChartColumn
                chartData={mainStats.currentregionscount && mainStats.currentregionscount.length > 0 ? mainStats.currentregionscount.map(item => ({
                  name: capitalizeFirstLetter(item.region),
                  value: item.count
                })) : []}
                chartName={t('Incidents per Region')}
                xAxis={t('Regions')}
                yAxis={t('# of Incidents')}
                className="charCanvas"
              />
            )}
          </div>
        </div>

        {/* Row 2 */}
        <div className="col-12 md:col-6">
          <div style={isMobile ? mobileChartContainerStyle : chartContainerStyle}>
            {isLoading ? (
              <div style={{ width: '100%' }}>
                <Skeleton width="60%" height="1rem" />
                <div style={{ marginTop: '10px' }}>
                  <Skeleton width="100%" height={isMobile ? "220px" : "280px"} />
                </div>
              </div>
            ) : (
              <HighChartPie
                chartData={mainStats.currentmaincategorycounts && mainStats.currentmaincategorycounts.length > 0 ? mainStats.currentmaincategorycounts.map(item => ({
                  name: item.broadcategory,
                  y: item.count
                })) : []}
                showLegend={false}
                chartName={t('Incidents per Main Category')}
                className="charCanvas"
              />
            )}
          </div>
        </div>
        
        <div className="col-12 md:col-6">
          <div style={isMobile ? mobileChartContainerStyle : chartContainerStyle}>
            {isLoading ? (
              <div style={{ width: '100%' }}>
                <Skeleton width="60%" height="1rem" />
                <div style={{ marginTop: '10px' }}>
                  <Skeleton width="100%" height={isMobile ? "220px" : "280px"} />
                </div>
              </div>
            ) : (
              <HighChartBar
                chartData={mainStats.currentcategorycounts && mainStats.currentcategorycounts.length > 0 ? mainStats.currentcategorycounts.map(item => ({
                  name: item.category,
                  value: item.count
                })) : []}
                chartName={t('Incidents per Category')}
                className="charCanvas"
              />
            )}
          </div>
        </div>

        {/* Row 3 */}
        <div className="col-12 md:col-6">
          <div style={isMobile ? mobileChartContainerStyle : chartContainerStyle}>
            {isLoading ? (
              <div style={{ width: '100%' }}>
                <Skeleton width="60%" height="1rem" />
                <div style={{ marginTop: '10px' }}>
                  <Skeleton width="100%" height={isMobile ? "220px" : "280px"} />
                </div>
              </div>
            ) : (
              <HighChartPie
                chartData={mainStats.currentvictimssexcount ? Object.entries(mainStats.currentvictimssexcount).map(([name, y]) => ({ name: capitalizeFirstLetter(name), y })) : []}
                showLegend={false}
                chartName={t("Incidents per Victim's Sex")}
                colors={['#1e8c8a;', '#64748b', '#E85E3F']}
                className="charCanvas"
              />
            )}
          </div>
        </div>
        
        <div className="col-12 md:col-6">
          <div style={isMobile ? mobileChartContainerStyle : chartContainerStyle}>
            {isLoading ? (
              <div style={{ width: '100%' }}>
                <Skeleton width="60%" height="1rem" />
                <div style={{ marginTop: '10px' }}>
                  <Skeleton width="100%" height={isMobile ? "220px" : "280px"} />
                </div>
              </div>
            ) : (
              <HighChartColumn
                chartData={mainStats.rightsviolatedcount && mainStats.rightsviolatedcount.length > 0 ? mainStats.rightsviolatedcount.map(item => ({
                  name: item.right,
                  value: item.count
                })) : []}
                chartName={t('Incidents per Rights Violated')}
                xAxis={t('Rights Violated')}
                yAxis={t('# of Incidents')}
                colors={['#64748b', '#E85E3F', '#1e8c8a;']}
                className="charCanvas"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home